var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D9E3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E3EBFF",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1407 28C18.25 28.1889 18.3949 28.4296 18.5744 28.7075C19.0354 29.4213 19.7182 30.3706 20.6045 31.3161C22.3955 33.2264 24.8995 35 28 35C31.1005 35 33.6045 33.2264 35.3955 31.3161C36.2818 30.3706 36.9646 29.4213 37.4256 28.7075C37.6051 28.4296 37.75 28.1889 37.8593 28C37.75 27.8111 37.6051 27.5704 37.4256 27.2925C36.9646 26.5787 36.2818 25.6294 35.3955 24.6839C33.6045 22.7736 31.1005 21 28 21C24.8995 21 22.3955 22.7736 20.6045 24.6839C19.7182 25.6294 19.0354 26.5787 18.5744 27.2925C18.3949 27.5704 18.25 27.8111 18.1407 28ZM39 28C39.8944 27.5528 39.8943 27.5524 39.8941 27.5521L39.8925 27.5489L39.889 27.542L39.8777 27.5198C39.8681 27.5013 39.8546 27.4753 39.8372 27.4424C39.8025 27.3767 39.752 27.2832 39.686 27.166C39.5542 26.9316 39.3601 26.6015 39.1057 26.2075C38.5979 25.4213 37.8432 24.3706 36.8545 23.3161C34.8955 21.2264 31.8995 19 28 19C24.1005 19 21.1045 21.2264 19.1455 23.3161C18.1568 24.3706 17.4021 25.4213 16.8943 26.2075C16.6399 26.6015 16.4458 26.9316 16.314 27.166C16.248 27.2832 16.1975 27.3767 16.1628 27.4424C16.1454 27.4753 16.1319 27.5013 16.1223 27.5198L16.111 27.542L16.1075 27.5489L16.1064 27.5512C16.1062 27.5516 16.1056 27.5528 17 28L16.1056 27.5528C15.9648 27.8343 15.9648 28.1657 16.1056 28.4472L17 28C16.1056 28.4472 16.1054 28.4468 16.1056 28.4472L16.1075 28.4511L16.111 28.458L16.1223 28.4802C16.1319 28.4987 16.1454 28.5247 16.1628 28.5576C16.1975 28.6233 16.248 28.7168 16.314 28.834C16.4458 29.0684 16.6399 29.3985 16.8943 29.7925C17.4021 30.5787 18.1568 31.6294 19.1455 32.6839C21.1045 34.7736 24.1005 37 28 37C31.8995 37 34.8955 34.7736 36.8545 32.6839C37.8432 31.6294 38.5979 30.5787 39.1057 29.7925C39.3601 29.3985 39.5542 29.0684 39.686 28.834C39.752 28.7168 39.8025 28.6233 39.8372 28.5576C39.8546 28.5247 39.8681 28.4987 39.8777 28.4802L39.889 28.458L39.8925 28.4511L39.8936 28.4488C39.8938 28.4484 39.8944 28.4472 39 28ZM39 28L39.8944 28.4472C40.0352 28.1657 40.0348 27.8336 39.8941 27.5521L39 28Z",
    fill: "#213366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 26C26.8954 26 26 26.8954 26 28C26 29.1046 26.8954 30 28 30C29.1046 30 30 29.1046 30 28C30 26.8954 29.1046 26 28 26ZM24 28C24 25.7909 25.7909 24 28 24C30.2091 24 32 25.7909 32 28C32 30.2091 30.2091 32 28 32C25.7909 32 24 30.2091 24 28Z",
    fill: "#213366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowBanner);
export default __webpack_public_path__ + "static/media/show-banner.f64d155107b340e2c9eca155a286c1da.svg";
export { ForwardRef as ReactComponent };